

export const menuData = [
    {
        id: 1,
        title: 'Home',

        link: 'http://www.google.com.br',
        target:"_blank",
        icon: true,
        iconName: null
    },
    {
        id: 2,
        title: 'Quem Somos',
        href:"who",
        link: 'http://www.google.com.br',
        target:"_blank",
        icon: true,
        iconName: null
    },

    {
        id:5,
        title:"",
        href:"#",
        imagem: true,
        target:"_blank",
        icon: true,
        iconName: null
    },
    {
        id: 3,
        title: 'Área de atuação',
        href:"fazemos",
        link: 'http://www.google.com.br',
        target:"_blank",
        icon: true,
        iconName: null
    },
    {
        id: 4,
        title: 'Contato',
        href:"contact",
        link: 'http://www.google.com.br',
        target:"_blank",
        icon: true,
        iconName: null
    },
]
